module.exports = __webpack_public_path__ + "img/find.898da6a2.png";